import moment from "moment";

export const WorkerOrderStateSortSequence = ["New", "Open", "Planning", "Planned", "In Progress", "Complete", "Closed"];
export const WorkerOrderPrioritySortSequence = ["", "Pending", "Low", "Normal", "High"];

export function sortAlphaNum(val1, val2, desc = false) {
  if ((typeof val1 !== "number" && typeof val1 !== "string") || (typeof val2 !== "number" && typeof val2 !== "string")) {
    return 0;
  }
  val1 = val1.toString();
  val2 = val2.toString();
  if (val1 === val2) return 0;

  let val1Segments = val1.match(/[a-z]+|\d+/gi);
  let val2Segments = val2.match(/[a-z]+|\d+/gi);
  let i1 = 0,
    i2 = 0;

  while (i1 < val1Segments.length || i2 < val2Segments.length) {
    let [val1Seg, val2Seg] = [val1Segments[i1], val2Segments[i2]];
    i1++;
    i2++;
    if (val1Seg === val2Seg) {
      continue;
    } else {
      !isNaN(val1Seg) && (val1Seg = val1Seg = parseInt(val1Seg));
      !isNaN(val2Seg) && (val2Seg = val2Seg = parseInt(val2Seg));
      if (desc) {
        return val1Seg > val2Seg ? 1 : -1;
      } else {
        return val1Seg < val2Seg ? 1 : -1;
      }
    }
  }

  return 0;
}

export function generalSortUsingStringAndNumbers(aVal, bVal) {
  if (aVal === bVal) {
    return 0;
  }

  if (typeof aVal === "string" && typeof bVal === "string") return aVal > bVal ? 1 : -1;
  if (typeof aVal === "number" && typeof bVal === "string") return 1;
  if (typeof aVal === "string" && typeof bVal === "value") return -1;

  return aVal > bVal ? 1 : -1;
}

export function sortUsingNumbers(a, b) {
  return Number(a) - Number(b);
}

export function generalSortUsingArrayIndex(aVal, bVal, sortSequence = []) {
  if (aVal === bVal) {
    return 0;
  }

  // if the value is not found in the given sort sequence, it will be considered -1
  const aReverse = sortSequence.indexOf(aVal);
  const bReverse = sortSequence.indexOf(bVal);

  return aReverse > bReverse ? 1 : -1;
}

export function generalSort(a, b) {
  let aVal = a.props.children;
  let bVal = b.props.children;
  if (aVal === bVal) {
    return 0;
  }
  const aReverse = aVal.split("").reverse().join("");
  const bReverse = bVal.split("").reverse().join("");
  return aReverse > bReverse ? 1 : -1;
}

export function dateSort(a, b) {
  const a1 = new Date(a).getTime();
  const b1 = new Date(b).getTime();
  if (a1 < b1) return 1;
  else if (a1 > b1) return -1;
  else return 0;
}

export function dateSortArrayByField(arr, field, asc = false) {
  return arr.sort((a, b) => {
    let a1 = "";
    let b1 = "";

    if (asc) {
      a1 = new Date(b[field]).getTime();
      b1 = new Date(a[field]).getTime();
    } else {
      a1 = new Date(a[field]).getTime();
      b1 = new Date(b[field]).getTime();
    }

    if (a1 < b1) return 1;
    else if (a1 > b1) return -1;
    else return 0;
  });
}



// WEBPACK FOOTER //
// ./src/utils/sortingMethods.js